import { finish, error } from '../../../modules/betslip/actions/offer-referred-betslip';
import { getEventsWithUuid } from './getEventsWithUuid';
import api from '../../../api';
var odds = require('odds-converter');

export async function request(dispatch, { id, bets, selections, channel, isFreeBet }) {
    bets.forEach(bet => {
        bet.stakePerLine = Math.round(100 * bet.stakePerLine);
        bet.channel = channel;
        bet.eachWay = bet.eachWay ? bet.eachWay : false;

        if ( !bet.freebet) {
            delete bet.freebetCredits;
        }

        bet.legs.forEach( leg => {
            if (leg.type === 'betBuilder') {
                // BB: keep legReference structure as-is
            } else if (leg.type !== 'empty') {
                leg.selection = { id: leg.selectionId };
                leg.market = { id: Number(leg.marketId) };
                leg.event = { id: leg.eventId };
            } else {
                leg.market = null;
                leg.selection = {
                    name: leg.selectionName
                };
                leg.event = {
                    name: leg.eventName
                };
            }

            leg.type = leg.type ? leg.type : 'standard';

            if (leg.price && !leg.price.f && !leg.price.d) {
                if (String(leg.price).includes('/')) {
                    const legArr = String(leg.price).split('/');
                    const d = odds.fraction.toDecimal(legArr[0],legArr[1]);
                    const f = leg.price;
                    leg.price = {
                        f,
                        d
                    };
                } else {
                    const d = leg.price;
                    const fraction = odds.decimal.toFractional(leg.price.d).simplify();
                    const f = `${fraction.n }/${ fraction.d}`;
                    leg.price = {
                        d,
                        f
                    };
                }
            }

            if (leg.price && leg.price.f && !leg.price.d) {
                const legArr = leg.price.f.split('/');
                leg.price.d = odds.fraction.toDecimal(legArr[0], legArr[1]);
            }

            if (leg.price && leg.price.d && !leg.price.f) {
                const fraction = odds.decimal.toFractional(leg.price.d).simplify();
                leg.price.f = `${fraction.n }/${ fraction.d}`;
            }

            if ( leg.type !== 'betBuilder' && leg.price && leg.price.f !== selections.getIn([ leg.selectionId, 'price', 'f' ])) {
                leg.ignoreProblems = [ 'Selection:price:decreased', 'Selection:price:increased' ];
            }
        });
    });
    bets = bets.filter(bet => bet.stakePerLine > 0);

    const selectionIdsWithUuid = await getEventsWithUuid(bets);

    bets.forEach(bet => {
        bet.legs.forEach(leg => {
            if (leg.type === 'betBuilder') {
                leg.uuid = null;
                return;
            }

            const uuid = (leg.type === 'empty' || selectionIdsWithUuid[leg.selectionId] === undefined || selectionIdsWithUuid[leg.selectionId] === null) ? undefined : selectionIdsWithUuid[leg.selectionId].uuid;

            if (uuid === undefined && leg.type !== 'empty') {
                console.error(`No uuid for eventId=${leg.eventId}`);
            }

            if (leg.type === 'empty') {
                leg.uuid = null;
            } else {
                leg.uuid = uuid;
            }
        });
    });

    api.put(`/customers/${ id }/offered-betslip`, { bets: bets }).then(
        (data) => dispatch(finish(id, data)),
        ({ errors }) => dispatch(error(id, errors))
    );
}
